import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import Identification from '../../Common/Identification';

import {PageDescription, StepBox} from '../../Common/PageComponents';

const stateToProps = state => {
  return {
    agreement: state.agreement,
  };
};

class IdentificationPage extends Component {
  componentDidMount() {
    if (!this.props.agreement.join) {
      alert(
        '회원가입 약관에 동의하지 않으셨다면 뒤로가기를 눌러 약관을 확인해주시고, 약관에 동의하셨을 경우 다음 절차를 진행해주세요.'
      );
      this.props.history.push('/member-service/join/agreement');
    }
  }

  render() {
    return (
      <div>
        <StepBox steps={['약관동의', '대표자 본인인증', 'PC방 정보입력', '가입완료']} activeIndex={1} />
        <PageDescription>
          안전한 서비스이용과 소중한 개인정보보호를 위해 가입 시 실명 인증 및 본인 확인 절차를 거치고 있습니다. <br />
          입력하신 정보는 저장되지 않으며, 신용평가기관을 통한 실명 확인 용도로만 사용됩니다.
        </PageDescription>
        <Identification nextUrl="/member-service/join/history" />
      </div>
    );
  }
}

export default withRouter(connect(stateToProps)(IdentificationPage));
